import tw from 'twin.macro';
import styled from 'styled-components';

export const TypingQuizContainer = styled.form`
  ${tw`w-full px-3 py-[2rem] flex flex-col  justify-center gap-2 z-10 bg-transparent`};
`;

export const TypingQuizItems = styled.div`
  ${tw`w-full flex flex-wrap justify-center items-center gap-3`}
`;
export const TypingQuizAction = styled.div`
  ${tw`w-full flex justify-around items-center gap-2.5 mt-10`}
`;

export const TypingQuizItemSkip = tw.div`flex items-center justify-center gap-1 cursor-pointer`;
